import { render, staticRenderFns } from "./operationPersonerManage.vue?vue&type=template&id=01ca7a0b&scoped=true&"
import script from "./operationPersonerManage.vue?vue&type=script&lang=js&"
export * from "./operationPersonerManage.vue?vue&type=script&lang=js&"
import style0 from "./operationPersonerManage.vue?vue&type=style&index=0&id=01ca7a0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca7a0b",
  null
  
)

export default component.exports